import { baseGlobals } from '@root/typescript/baseGlobals'

import DOM from '@common/DOM/DOM'

import { EHttpStatusCode } from '@common/http/definitions'

import AuthError from '../AuthError/AuthError'
import AuthInput from '../AuthInput/AuthInput'

import styles from './Auth.css'

export interface IAuthProps {
  readonly action: string
  readonly onSuccess?: (res: unknown, xhr: XMLHttpRequest, form: HTMLFormElement) => void
}

/**
 * Ajax-alapú bejelentkezési form factory-ja.
 * @param props - JSX props {@link IAuthProps}.
 */
export default function Auth (props: IAuthProps): HTMLElement {
  const form: HTMLFormElement = (
    <form className={ styles.authForm }>
      <AuthInput name="username" title="username" type="text" />
      <AuthInput name="password" title="password" type="password" />
      <AuthInput type="submit" />
    </form>
  )

  form.addEventListener('submit', async (e: Event): Promise<void> => {
    e.preventDefault()

    const { default: ajax } = await import(
      /* webpackChunkName: "ajax" */
      '@common/ajax/v1/ajax'
    )

    ajax(
      props.action.startsWith('/') ? props.action : `/${ props.action }`,
      {
        data: form,
        /**
         * Sikeres bejelentkezés esetén (200) ez a callback fut meg.
         * @param res - A válasz.
         * @param xhr - A példányosított XHR.
         */
        success: (res: unknown, xhr: XMLHttpRequest) => {
          if (props.onSuccess) {
            props.onSuccess(res, xhr, form)
          }
          // Legacy okokból ez megmarad.
          else {
            window.location.reload()
          }
        },
      /**
       * Hiba esetén (nem 200) ez a callback fut meg.
       * @param _response - A válasz, ami lehet bármi.
       * @param xhr       - Az xhr objektum.
       */
        error: (_response, xhr: XMLHttpRequest): boolean | void => {
          if (baseGlobals.isDev && xhr.status === EHttpStatusCode.InternalServerError) {
            return false
          }

          const error = form.querySelector('.auth-error-container')

          if (error) {
            DOM.remove(error)
          }

          form.appendChild(<AuthError />)
        }
      }
    )
  })

  return (
    <div className={ styles.auth }>
      { form }
    </div>
  )
}
